import { LIMIT_TYPE } from '@/components/Limits/constants'
import { DAY_SEC, HOUR_SEC } from '@/constants/time'
import { DELIMITER_GAME, BE_LIMIT_TYPE, DELIMITER_DEPOSIT } from '@/components/Limits/constants'

export default (client) => {
  const root = 'user-limits'
  const version = 'v4'

  return {
    /**
     * @returns {Promise<Response<GetLimitsResponse>>}
     * */
    list() {
      const url = `/${version}/${root}/info`

      return client.get(url)
    },

    /**
     * @param {object} SetLimitDTO
     * @param {string} SetLimitDTO.type
     * @param {number} SetLimitDTO.limit
     * @param {string} [SetLimitDTO.delimiter]
     *
     * @returns {Promise<Response<{ status: boolean}>>}
     * */
    update({ type, limit, delimiter }) {
      const url = `/${version}/${root}/set`

      const isTypeDeposit = type === LIMIT_TYPE.DEPOSIT

      if (isTypeDeposit) {
        limit = limit * 100
      }
      else if (type === LIMIT_TYPE.GAME_DAY) {
        delimiter = DELIMITER_GAME.DAY
        limit = limit * HOUR_SEC
      }
      else if (type === LIMIT_TYPE.GAME_WEEK) {
        delimiter = DELIMITER_GAME.WEEK
        limit = limit * DAY_SEC
      }
      type = isTypeDeposit ? BE_LIMIT_TYPE.DEPOSIT : BE_LIMIT_TYPE.GAME_SESSION
      // set default value for delimiter
      if (isTypeDeposit && !delimiter) delimiter = DELIMITER_DEPOSIT.MONTH

      return client.post(url, { type, limit, delimiter })
    },
  }
}

/**
 * @typedef {object} Limit
 * @property {string} _id
 * @property {number} user_id
 * @property {string} type
 * @property {string} delimiter
 * @property {number} limit
 * @property {number} used_limit
 * @property {string} period_start_at
 * @property {string} updated_at
 * @property {boolean} is_applied_for_changes
 */

/**
 * @typedef {object} GetLimitsResponse
 * @property {boolean} status
 * @property {object} result
 * @property {boolean} result.is_enabled
 * @property {object} result.pause
 * @property {number} result.pause.countdown
 * @property {number} result.pause.pause_sec
 * @property {Limit[]} result.limits
 */
